import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import DataTable from '../../common/components/DataTable';
import FilterView from '../../common/components/FilterView';
import { IDataTableColumn } from '../../common/types/dataTable';
import { AppDispatch, RootState } from '../template/store';
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';

import queryString from 'query-string';
import {
  Outlet,
  matchPath,
  useLocation,
  useNavigate,
  useParams,
} from 'react-router-dom';

import OblDetails from '../../common/components/OblDetails';
import { AESDecrypt, AESDecryptAny, AESEncrypt } from '../../../encrypt-util';
import {
  IConfigsDefinition,
} from '../../utils/columnConfig';

import { getColumnViews } from '../../common/actions/dataTable';
import {
  clearReportGrid,
  updateDashbaordRefresh,
  updateParams,
  updateSortStateDataTable,
} from '../../common/components/DataTable/slices/DataTable';
import { getDashboardData } from '../dashboard/actions/dashboard';
import { updateCurrentPageReportDashboard } from '../dashboard/slices/dashboardSlice';
import { updateDashbaordName } from '../../common/slices/navbarTop';

import moment from 'moment';
import DashboardContainer from '../../../components/common/DashboardContainer';
import useDataCountry from '../../../hooks/useDataCountry';
import {
  selectReportInstruction,
  toggleColumnSettingsPayDash,
} from './reportSlice';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmarkCircle } from '@fortawesome/free-solid-svg-icons';
import useReportGridName, { reportMap } from './useReportGridName';
import { getReportTypes } from '../dashboard/actions/instruction';
import { useAmountFormatter } from '../../../hooks/useAmountFormatter';
import { useGenerateColumnConfig } from '../../../hooks/useGenerateColumnConfig';
import { getUnprefixedPathname } from '../../../helpers/utils';
import { updateSelectedBlListMultiPayTable, updateSelectedRowsInvoice } from '../multiBlPayment/slices/multiBlPaymentSlice';


const ReportDashboard = () => {
  const dataCountry = useDataCountry();
  /*   const gridSort = dataCountry == 'VN' ? 'inv_no desc' : 'bl_no desc'; */
  const gridSort =
    dataCountry === "VN"
      ? "inv_no desc" :
      dataCountry === "SA"
      ? "inv_no desc"
      : dataCountry === "TZ"
        ? "do_number desc"
        : "bl_no desc";

  const { blNum } = useParams();
  const prevDataRef = useRef < any > (null)
  const isUpdatingSelectionsRef = useRef(false)
  // Add a ref to track the last selection state we calculated
  const lastCalculatedSelectionsRef = useRef < Record < number, boolean>> ({})
  const navigate = useNavigate();
  const reportList = useSelector(
    (state: RootState) => state.reportDashboard.reportList
  );
  // Track if we need to sync selections to the table
  const needToSyncSelectionsRef = useRef(true)
  // Track the last known selection state for comparison
  const lastKnownSelectionsRef = useRef < string[] > ([])
  const selectedRowsInvoice = useSelector((state: RootState) => state.multiBlPayment.selectedRowsInvoice)
  const selectionInitialState = useSelector((state: RootState) => state.multiBlPayment.selectedRowsMultiPayTable)
  const dispatch = useDispatch < AppDispatch > ();
  const location = useLocation();
  const [columns, setColumns] = useState < IDataTableColumn[] > ([]);
  const [configs, setConfigs] = useState < IConfigsDefinition > ({
    columns: [],
    staticHiddenCols: [],
    defaultHiddenCols: [],
  });
  useEffect(()=>{
    dispatch(clearReportGrid())
  }, [dataCountry])

  useEffect(() => {
    const localData = AESDecryptAny(window.localStorage.getItem('@linerReportInstruct'));
    
    if (localData && reportList?.map((i: any) => i.value).includes(localData)) {
      dispatch(selectReportInstruction(localData));
    } else if (reportList?.length >= 1) {
      dispatch(selectReportInstruction(reportList?.[0]?.value));
    } else {
      dispatch(selectReportInstruction(''));
    }
  }, [reportList]);

  const { reportGridName: defaultReportGridName, reportGridFilterKey: defaultReportGridFilterKey, reportGridSortState } = useReportGridName();




  //const reportGridName = dataCountry === "VN" ? "INVOICE_DETAILS_VN" : defaultReportGridName;
  // let reportGridName: any//= defaultReportGridName;

  // if (dataCountry === "VN") {
  //   reportGridName = "INVOICE_DETAILS_VN";
  // } else if (dataCountry === "TZ") {
  //   reportGridName = "DO_INTEGRATION_REPORT";
  // } else {
  //   reportGridName = defaultReportGridName;
  // }

  const reportGridName = defaultReportGridName;
  // const reportGridFilterKey = dataCountry === "VN" ? "reportGridFilterKey" : defaultReportGridFilterKey;

 const reportGridFilterKey = defaultReportGridFilterKey;

  const currentPage = useSelector(
    (state: RootState) => state.dashboard.currentPageReport
  );

  const data = useSelector(
    (state: RootState) => state.dashboard.reportDashboardList
  );

  const filterState = useSelector(
    (state: RootState) => state.dataTable.filterState
  );
  const grids = useSelector((state: RootState) => state.dataTable.reportGrids);
  const [previousState, setPreviousState] = useState < {
    filterState: string | null;
    search: string | null;
    grids: any[] | null;
  } > ({
    filterState: '{}',
    search: '',
    grids: grids?.[0]?.gridId,
  });
  const [currentState, setCurrentState] = useState < {
    filterState: string | null;
    search: string | null;
    grids: any[] | null;
  } > ({
    filterState: '{}',
    search: '',
    grids: grids?.[0]?.gridId,
  });
  const profileDetails = useSelector(
    (state: RootState) => state.userProfile.profile
  );
  const [localSelections, setLocalSelections] = useState < Record < number, boolean>> ({})
  const setCurrentPage = (page: number) => {
    dispatch(updateCurrentPageReportDashboard(page));
  };
  const linerId = useSelector((state: RootState) => state.navbarTop.linerId);
  const language = useSelector((state: RootState) => state.navbarTop.language);
  const topSearchState = useSelector(
    (state: RootState) => state.navbarTop.reportTopSearchState
  );
  const selectedConfigId = useSelector(
    (state: RootState) => state.dataTable.selectedConfigId
  );
  const selectedTopSearchFilter = useSelector(
    (state: RootState) => state.navbarTop.selectedTopSearchFilter
  );
  const searchInputValue = useSelector(
    (state: RootState) => state.navbarTop.searchInputValue
  );
  const lastSelectionsRef = useRef({});

  const generateColumnConfig = useGenerateColumnConfig()
  const refresh = useSelector(
    (state: RootState) => state.dataTable.refreshDashboard
  );
  useEffect(() => {
    if (refresh) loadDashboard(false);
    // server sometimes takes time to update the view so the delay
    setTimeout(() => dispatch(updateDashbaordRefresh(false)), 2000);
  }, [refresh]);
  useEffect(() => {
    const dashboardDefinition = grids?.[0]?.columnConfigGrid || '';

    if (!dashboardDefinition) return;

    try {
      const configs = generateColumnConfig(
        JSON.parse(JSON.parse(dashboardDefinition)),
        getParams,
      );

      const columns = configs?.columns?.map((c) => c);
      setConfigs(configs);
      setColumns(columns);
    } catch (e) {
      console.error('Column Error: ', e);
    }
  }, [grids, location]);
  useEffect(() => {
    if (!data?.result || !Array.isArray(data.result) || !Array.isArray(selectedRowsInvoice)) return

    // Always sync when data changes
    console.log("Data or selections changed, syncing table state")

    // Create a selection object where keys are row indices and values are true for selected rows
    const tableSelections: Record<number, boolean> = {}

    // Find the indices of rows that match the selected BL numbers
    data.result.forEach((row, index) => {
      if (row.inv_no && selectedRowsInvoice.includes(row.inv_no)) {
        tableSelections[index] = true
      }
    })

    console.log("Syncing table selections:", tableSelections)
    console.log("selectedRowsInvoice:", selectedRowsInvoice)

    // Update the table's selection state
    dispatch(updateSelectedBlListMultiPayTable(tableSelections))
  }, [data, selectedRowsInvoice])



  useEffect(() => {
    if(dataCountry && linerId){
      dispatch(getReportTypes({ partnerCountry: dataCountry, linerId: linerId }));
    }
  }, [dataCountry, linerId]);

  useEffect(() => {
    console.log("reportGridName", grids)
    dispatch(updateDashbaordName(reportGridName));
  }, [reportGridName]);
  const filterStateLocal = filterState?.[reportGridFilterKey];
  const sort = (queryString.parse(location.search)?.sort as string)
    ?.split?.(',')
    ?.join?.(' ');

  useEffect(() => {
    let timer = setTimeout(() => {
    if (location?.pathname && dataCountry && reportGridName && linerId) {
      dispatch(
        getColumnViews({
          gridName: reportGridName,
          country: dataCountry,
          linerId: linerId,
          language: language || localStorage.getItem('selectedLanguage') || 'EN',
        })
      );
    }
    dispatch(updateParams({}));
    dispatch(
      updateSortStateDataTable({
        key: null,
      })
    );
    }, 150);

    return () => clearTimeout(timer);

  }, [dataCountry, reportGridName, reportList, linerId, language]);
  const _onSelect = (data: any) => {

  };

  useEffect(() => {
    loadDashboard(false);
  }, [currentPage]);

  useEffect(() => {
    if (matchPath(location.pathname, '/reports')) loadDashboard(false);
  }, [location.pathname]);

  useEffect(() => {
    const currentState = {
      filterState: JSON.stringify(filterStateLocal),
      search: location.search,
      grids: grids?.[0]?.gridId,
    };
    if (JSON.stringify(previousState) !== JSON.stringify(currentState)) {
      setCurrentState({
        filterState: JSON.stringify(filterStateLocal),
        search: location.search,
        grids: grids?.[0]?.gridId,
      });
    }
  }, [filterStateLocal, location.search, grids]);

  useEffect(() => {
    if (JSON.stringify(previousState) !== JSON.stringify(currentState)) {
      loadDashboard(true);
      setPreviousState(currentState);
    }
  }, [currentState]);

  useEffect(() => {
    loadDashboard(true);
  }, [language]);

  const loadDashboard = (filterUpdated: boolean) => {
    if (filterUpdated) setCurrentPage(1);

    const filterApiState: any = {};
    if (filterStateLocal && Object.keys(filterStateLocal).length > 0) {
      const filterKeys = Object.keys(filterStateLocal);
      for (let k of filterKeys) {
        const filterValue = filterStateLocal?.[k];

        if (typeof filterValue === "object" && filterValue !== null && ('from' in filterValue || 'to' in filterValue)) {
          const fromVal = filterValue.from;
          const toVal = filterValue.to;

          if (fromVal === "" && toVal === "") {
            filterApiState[k] = undefined;
          } else if (fromVal != null || toVal != null) {
            filterApiState[k] = [fromVal, toVal];
          } else {
            filterApiState[k] = undefined;
          }
        } else if (typeof filterValue === "string" && filterValue.trim() !== "") {
          filterApiState[k] = [filterValue];
        } else if (Array.isArray(filterValue) && filterValue.length > 0) {
          filterApiState[k] = filterValue;
        } else {
          filterApiState[k] = undefined;
        }
      }
    }
    console.log('loadDashboard - filterApiState (after loop):', filterApiState);

    const finalFilterApiState: any = selectedTopSearchFilter?.id && searchInputValue.trim() != ''
      ? { [selectedTopSearchFilter?.id]: [searchInputValue.trim()] }
      : {};

    if (grids[0]) {
      let timeFlag = '';
      let timeDiff = 0;
      let dateRange: any = {};

      const newdata = grids[0].configGroup?.find(
        (c: any) => c.userGridId == selectedConfigId?.[reportGridFilterKey]
      )?.columnConfigGrid;
      if (newdata) {
        timeFlag = JSON.parse(newdata).find(
          (item: any) => item.accessor == 'invdt'
        )?.filterState;
        timeDiff = JSON.parse(newdata).find(
          (item: any) => item.accessor == 'invdt'
        )?.timeDiff;
        dateRange = JSON.parse(newdata).find(
          (item: any) => item.accessor == 'invdt'
        )?.dateRange;
      }
      if (filterApiState.invdt && timeFlag == 'day' && dateRange) {
        filterApiState.invdt[1] = moment()
          .subtract(Math.abs(dateRange.to), 'days')
          .endOf('day')
          .toISOString();
        filterApiState.invdt[0] = moment()
          .subtract(Math.abs(dateRange.from), 'days')
          .startOf('day')
          .toISOString();
      }
    }

    for (let i of Object.keys(filterApiState)) {
      if (filterApiState[i] !== undefined) {
        finalFilterApiState[i] = filterApiState[i];
      }
    }
    if (finalFilterApiState.is_final_amt_available) {
      const val = finalFilterApiState.is_final_amt_available[0];
      if (val && (val.toLowerCase() === "yes" || val === "Y")) {
        finalFilterApiState.is_final_amt_available = ["Y"];
      } else if (val && (val.toLowerCase() === "no" || val === "N")) {
        finalFilterApiState.is_final_amt_available = ["N"];
      }
    }
    console.log('loadDashboard - finalFilterApiState (before dispatch):', finalFilterApiState);

    // Debugging profile and grid conditions before dispatch
    console.log('loadDashboard - profileDetails.partnerType:', profileDetails.partnerType);
    console.log('loadDashboard - profileDetails.partnerId:', profileDetails.partnerId);
    console.log('loadDashboard - grids?.[0]?.whereClause:', grids?.[0]?.whereClause);


    if (
      (profileDetails.partnerType === 'customer' && profileDetails.partnerId) ||
      profileDetails.partnerType === 'liner'
    ) {
      setTimeout(() => {
        dispatch(
          getDashboardData({
            gridName: reportGridName,
            payload: {
              fields: /*  SelectedViewFields?.fields || */[],
              filters: finalFilterApiState,
              size: 20,
              sorts: sort ? [sort] : [reportGridSortState],
              page: filterUpdated ? 1 : currentPage,
            },
            dataCountry: dataCountry,
            partnerId:
              profileDetails.partnerType === 'customer'
                ? profileDetails.partnerId
                : null,
            where: grids?.[0]?.whereClause
              ? AESEncrypt(grids?.[0]?.whereClause)
              : null,
            parameter:
              selectedTopSearchFilter?.where !== ''
                ? {
                  searchParameter: searchInputValue,
                  searchWhere: selectedTopSearchFilter?.where,
                }
                : {},
          })
        );
      }, 250);
    }
  };

  const showColumnSettings = useSelector(
    (state: RootState) => state.reportDashboard.showColumnSettings
  );

  const getParams = () => {
    return {
      blid: blNum ? AESDecrypt(blNum) : '',
      pmtmode: blNum ? AESDecrypt(blNum) : '',
    };
  };

  useEffect(() => {
    dispatch(updateParams({}));
    dispatch(
      updateSortStateDataTable({
        key: null,
      })
    );
  }, [dataCountry]);

  const APP_PATH_PREFIX = process.env.REACT_APP_APP_PATH_PREFIX || '';

  const sideWidth =
    Object.entries({
      [`${APP_PATH_PREFIX}/report`]: 0,
    }).find(([path, _]) => matchPath(path, location.pathname))?.[1] ?? 9;

  return (
    <DashboardContainer
      sideWidth={sideWidth}
      middleChildren={
        getUnprefixedPathname().split('/')[1] == 'blsliderinvoice' ? (
          <OblDetails
            blslider={`/blsliderinvoice/${getUnprefixedPathname().split('/')[1]}`}
          />
        ) : (
          <div className={`flex-1 h-100 smoothDiv w-100`}>
            <Outlet />
          </div>
        )
      }
    >
      <FilterView
        loadList={loadDashboard}
        showReportDropdown={true}
        showUploadButton
        showExport={true}
        showColumnSettings={true}
        dataLoading={false}
        toggleColumnSettings={toggleColumnSettingsPayDash}
        columnSettingsPersistKey='@odex/report/v1'
        uniqueFilterKey={reportGridFilterKey}
        configViews={
          grids?.find?.((g) => g?.gridName === reportGridName)?.configGroup || []
        }
        showRightDiv={!!matchPath(location.pathname, '/report') && !!reportGridName}
        dashboardName={reportGridName}
        data={data}
        gridDef={grids}
      />
      {!reportGridName && (
        <div className='flex-1 d-flex h-100 align-items-center justify-content-center'>
          <span
            className='f-1'
            style={{
              userSelect: 'none',
            }}
          >
            <FontAwesomeIcon icon={faXmarkCircle} /> No Reports Found
            <br />
            <br />
            <br />
            <br />
          </span>
        </div>
      )}
      {reportGridName && columns?.length > 0 && (
        <DataTable
          data={data?.result || null}
          columns={columns}
          dataCountry={dataCountry || ''}
          sortable
          searchable={false}
          showColumnFilter={true}
          selectionInitialState={selectionInitialState}
          selection={dataCountry === 'VN'}
          perPage={20}
          pagination
          numberPagination
          maxPage={parseInt(data?.maxPage || '100')}
          hasNext={data?.hasNext}
          currentPage={currentPage}
          gridId={grids?.[0]?.gridId || 0}
          onChangePageNumber={(pageNumber) => setCurrentPage(pageNumber)}
          showExport={false}
          showColumnSettings={showColumnSettings}
          onHide={() => {
            dispatch(toggleColumnSettingsPayDash(false));
          }}
          columnSettingsPersistKey='@odex/report/v1'
          customSort={true}
          uniqueFilterKey={reportGridFilterKey}
          staticHiddenCols={configs?.staticHiddenCols || []}
          defaultHiddenCols={[]}
          tableMinHeight={400}
          gridName={reportGridName}
          dataLoading={false}
          configGroup={grids?.[0]?.configGroup || []}
          onCustomSelectChange={_onSelect}
          disableRowSelection={{
            accessor: 'payment',
            value: 'Paid',
          }}
          onSelectRow={(dat) => {
            console.log('Selection data:', dat?.action, dat);

            const currentSelections = Array.isArray(selectedRowsInvoice) ? [...selectedRowsInvoice] : [];

            if (dat?.action === 'add') {
              if (Array.isArray(dat?.data)) {

                const allRows = dat.data.filter((row: any) => row && row.inv_no); // Filter out any invalid rows
                dispatch(updateSelectedRowsInvoice(allRows));
              } else if (dat?.data?.inv_no) {

                const rowToAdd = dat.data; // Use the entire row object

                // Check if this row is already in the selections
                const isAlreadySelected = currentSelections.some(
                  item => item.inv_no === rowToAdd.inv_no
                );

                const newSelections = isAlreadySelected
                  ? currentSelections
                  : [...currentSelections, rowToAdd];

                dispatch(updateSelectedRowsInvoice(newSelections));
              }
            }

            if (dat?.action === 'remove') {
              if (Array.isArray(dat?.data) || dat?.data === 'all') {

                dispatch(updateSelectedRowsInvoice([]));
              } else if (dat?.data?.inv_no) {

                const invNoToRemove = dat.data.inv_no;

                // Filter out the row with the matching inv_no
                const newSelections = currentSelections.filter(
                  (item) => item.inv_no !== invNoToRemove
                );

                // Always clear all selections when deselecting
                dispatch(updateSelectedRowsInvoice([]));
              }
            }

            console.log("selectedRows after update:", selectedRowsInvoice);
          }}



        />

      )}
    </DashboardContainer>
  );
};

export default ReportDashboard;
